import React from 'react';
import { motion } from 'framer-motion';
import { Trophy } from 'lucide-react';
export function Results() {
  const results = ['Entrás a sesión con más claridad.', 'Diseñás sesiones con foco y dirección.', 'Preparás al deportista para competir con más recursos.', 'Trabajás con más seguridad, orden y autoridad profesional.'];
  return <section className="bg-emerald-900 py-12 md:py-20" data-id="element-188">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-189">
        <div className="mx-auto max-w-3xl text-center mb-8 md:mb-10" data-id="element-190">
          <div className="mb-4 inline-flex h-12 w-12 md:h-14 md:w-14 items-center justify-center rounded-full bg-emerald-800 text-emerald-400 border border-emerald-700" data-id="element-191">
            <Trophy className="h-6 w-6 md:h-7 md:w-7" data-id="element-192" />
          </div>
          <h2 className="text-2xl text-white md:text-4xl font-display" data-id="element-193">
            EL RESULTADO
          </h2>
        </div>

        <div className="mx-auto max-w-2xl bg-slate-950 rounded-2xl p-6 md:p-10 shadow-2xl border border-emerald-900/50" data-id="element-194">
          <ul className="space-y-4 md:space-y-5" data-id="element-195">
            {results.map((result, idx) => <motion.li key={idx} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.05
          }} className="flex items-center gap-3 text-sm md:text-base text-slate-300 font-medium" data-id="element-196">
                <div className="h-1.5 w-1.5 md:h-2 md:w-2 rounded-full bg-emerald-500 shrink-0" data-id="element-197" />
                {result}
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}